import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const NetworkOLTRoutes = defineRoute({
    record: {
        route: {
            path: "/network-olt",
            component: () => loadView(import("./NetworkOLTTable.vue")),
        },
    },
    create: {
        route: {
            path: "/network-olt/create",
            component: () => loadView(import("./NetworkOLTCreate.vue")),
        },
    },
    createDBA: {
        route: {
            path: "/network-olt/create/:id/dba",
            component: () => loadView(import("./NetworkOLTCreateDBAProfile.vue")),
        },
        build(id: string) {
            return `/network-olt/create/${id}/dba`;
        },
    },
    createSRV: {
        route: {
            path: "/network-olt/create/:id/srv",
            component: () => loadView(import("./NetworkOLTCreateSRVProfile.vue")),
        },
        build(id: string) {
            return `/network-olt/create/${id}/srv`;
        },
    },
    createLine: {
        route: {
            path: "/network-olt/create/:id/line",
            component: () => loadView(import("./NetworkOLTCreateLineProfile.vue")),
        },
        build(id: string) {
            return `/network-olt/create/${id}/line`;
        },
    },
    createTR069: {
        route: {
            path: "/network-olt/create/:id/tr069",
            component: () => loadView(import("./NetworkOLTCreateTR069Profile.vue")),
        },
        build(id: string) {
            return `/network-olt/create/${id}/tr069`;
        },
    },
    createVLAN: {
        route: {
            path: "/network-olt/create/:id/vlan",
            component: () => loadView(import("./NetworkOLTCreateVLAN.vue")),
        },
        build(id: string) {
            return `/network-olt/create/${id}/vlan`;
        },
    },
    update: {
        route: {
            path: "/network-olt/update/:id",
            component: () => loadView(import("./NetworkOLTUpdate.vue")),
        },
        build(id: string) {
            return `/network-olt/update/${id}`;
        },
    },
    updateFrame: {
        route: {
            path: "/network-olt/update/:id/frame/:i",
            component: () => loadView(import("./NetworkOLTUpdateFrame.vue")),
        },
        build(params: { id: string; oid: number }) {
            return `/network-olt/update/${params.id}/frame/${params.oid}`;
        },
    },
    updateVLAN: {
        route: {
            path: "/network-olt/update/:id/vlan/:i",
            component: () => loadView(import("./NetworkOLTUpdateVLAN.vue")),
        },
        build(params: { id: string; oid: number }) {
            return `/network-olt/update/${params.id}/vlan/${params.oid}`;
        },
    },
    updateONT: {
        route: {
            path: "/network-olt/update/:id/ont/:f/:s/:p/:i",
            component: () => loadView(import("./NetworkOLTUpdateONT.vue")),
        },
        build(params: { id: string; f: number; s: number; p: number; oid: number }) {
            return `/network-olt/update/${params.id}/ont/${params.f}/${params.s}/${params.p}/${params.oid}`;
        },
    },
});
